
jQuery('body').on('click','.toggle-grid-btn', function() {
  jQuery('.toggle-grid-btn').removeClass('active');
  jQuery(this).addClass('active');
  var productGrid = jQuery('.collection__results');
  var cols = jQuery(this).attr('data-cols');
  jQuery('.collection__results').attr('data-cols',cols);
});

if(jQuery('body').hasClass('p-collection')){
  document.addEventListener('DOMContentLoaded', function() {
    var options = document.querySelector('.facets__floating-filter ');
  
    window.addEventListener('scroll', function() {
      if (window.scrollY >= 200) {
        options.classList.add('active');
      } else {
        options.classList.remove('active');
      }
    });
  });
}
window.addEventListener('scroll', function() {
  if(isInViewport(document.querySelector('.product-info__buy-buttons'))){
    jQuery('product-quick-add.product-quick-add').css('opacity',1);
    jQuery('product-quick-add.product-quick-add').css('visibility','visible');
  }else{
    jQuery('product-quick-add.product-quick-add').css('opacity',0);
    jQuery('product-quick-add.product-quick-add').css('visibility','hidden');
  }

});
// Function to check if an element is in the viewport
function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top <= 0 &&
        rect.bottom <= 0   
    );
}

// Function to handle scroll event
function handleScroll() {
    const element = document.querySelector('.product-info__buy-buttons .buy-buttons');
   
    if (!isInViewport(element)) {
        document.querySelector('.shopify-section--main-product .product-quick-add').classList.remove('active');
    }else{
        document.querySelector('.shopify-section--main-product .product-quick-add').classList.add('active');
    }

}

jQuery('body').on('change','[name=collection]',function(){
    jQuery('form#facet-form').attr('action',jQuery('[name=collection]:checked').val());
});
document.addEventListener('facet:refreshed',function(event){
   splited = collectionRemove.split('/');
   collectionRemove = splited[splited.length - 1]
   jQuery('#collection-furl,.collection-furl').attr('href',window.location.href.replace(collectionRemove,'all'));
});
jQuery(document).ready(function(){
  jQuery('#collection-furl,.collection-furl').attr('href',window.location.href.replace(collectionRemove,'all'));
});
if(document.querySelector('.product-info__variant-picker .variant-picker')){
 document.forms[document.querySelector('.product-info__variant-picker .variant-picker').getAttribute("form")]?.addEventListener("variant:change", function(e){
    var count = productVariants['a'+ e.detail.variant.id];

     if(count <= 2 && count != 0){
         document.querySelector('span.inventoryNote.form__label').textContent = 'Only ' + count + ' left in stock';
     }else{
         document.querySelector('span.inventoryNote.form__label').textContent = '';
     }
    
 });
}